import { create } from 'zustand';

export type ModalStoreState = {
  isOpen: boolean;
};

export type ModalStoreActions<T> = {
  close: () => void;
  closeWithoutReset: () => void;
  open: (customData?: T) => void;
  toggle: () => void;
};

export type AnyModalStore = {
  getState: () => { close: () => void; isOpen: boolean };
};

const modalStoreRegistry = new Set<AnyModalStore>();

export const createModalStore = <T>(initialData?: T, isOpen = false) => {
  const store = create<ModalStoreActions<T> & ModalStoreState & T>((set) => ({
    ...(initialData || ({} as T)),
    close: () =>
      set((state) => {
        return {
          ...state,
          ...initialData,
          isOpen: false,
        };
      }),
    closeWithoutReset: () =>
      set((state) => {
        return {
          ...state,
          isOpen: false,
        };
      }),
    isOpen,
    open: (customData?: T) =>
      set((state) => {
        if (customData) {
          return {
            ...state,
            ...customData,
            isOpen: true,
          };
        }

        return { ...state, isOpen: true };
      }),
    toggle: () => set((state) => ({ ...state, isOpen: !state.isOpen })),
  }));

  modalStoreRegistry.add(store);

  return store;
};

export const closeAllModalsExcept = (except: AnyModalStore) => {
  modalStoreRegistry.forEach((store) => {
    if (store === except) {
      return;
    }

    const { close, isOpen } = store.getState();

    if (isOpen) {
      close();
    }
  });
};
